import styled from 'styled-components';
import * as GStyled from '../../../../styles/components';

const FieldActionMenuItem = styled(GStyled.LinkButton)`
  color: ${(props): string => props.theme.colors.lqBlue};
  cursor: pointer;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }

  > span {
    display: grid;
    grid-template-columns: 1.2rem 1fr;
    grid-gap: ${(props): string => props.theme.spaces.md};
    align-items: center;
    justify-items: start;

    padding-left: 0;
    padding-right: 0;
  }
`;

export { FieldActionMenuItem };
